import React, { useEffect, useState, useRef } from 'react'
// import { Modal,StyleSheet, StatusBar,Dimensions, Platform,Animated,Easing} from 'react-native';
import { Colors, Metrics } from '../../global'
import LoadingSVG from '../../Assets/SVG/StratusLoadingBlue.svg'
import { Spin } from 'antd';

const LoadingIcon = ({style}) => {
    // if(style == undefined) style={...Metrics.verticalMargin,height:48,width:48,color:Colors.primary}
    // const animation = useRef(new Animated.Value(0)).current;
    // const rotation = animation.interpolate({
    //                     inputRange: [0, 1],
    //                     outputRange: ['0deg', '360deg']
    //                 });
    // const loop = useRef(Animated.loop(
    //     Animated.timing(animation, {toValue: 1, duration: 2000,easing: Easing.linear,useNativeDriver: true}),
    //     )).current;
    // useEffect(()=>{
    //     loop.start()
    //     return () => {
    //         loop.stop()
    //     }
    // }, [])

    return (
        <Spin size="large" />
        // <Animated.View
        //   style={{...style,transform: [{rotate: rotation}]}}
        // >
        // <LoadingSVG 
        //   height={style.height}
        //   width={style.height}
        //   color={style.color}
        // />
        // </Animated.View>
    )
}

export default LoadingIcon